import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface ILoanEligibilityReportState {
  data?: {
    data?: any[]
    meta?: any
  }
  loading?: boolean
}

const initialState: ILoanEligibilityReportState = {
  data: {data: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: ILoanEligibilityReportState = initialState,
  action: ActionWithPayload<ILoanEligibilityReportState>
) => {
  switch (action.type) {
    case actionTypes.GET_LOAN_ELIGIBILITY_REPORT_START:
      return {...state, loading: true}
    case actionTypes.GET_LOAN_ELIGIBILITY_REPORT_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_LOAN_ELIGIBILITY_REPORT_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
